import { atom } from 'jotai';

export const isSidebarCollapsedAtom = atom(true);
// export const agentSidebarOpenAtom = atom(false);